import mapboxgl from 'mapbox-gl';
import React, { ComponentType, useEffect, useRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import MarkerPoint from 'components/Marker/MarkerPoint';
import { useAppSelector } from 'hooks/useAppSelector';
import kwadHubTheme, { styled } from 'theme';
import { ThemeProvider } from '@mui/material';

const MapPlaceholderDiv = styled('div')(({ theme }) => ({
    height: '280px',
    width: '100%',
    borderRadius: theme.shape.borderRadius,
}));

const MiniMapContainer = styled('div')({
    position: 'relative',
});

const MapPlaceholder: ComponentType = () => {
    const spotsData = useAppSelector((state) => state.spots);

    const mapContainerRef = useRef<HTMLDivElement | null>(null);

    const { openingSpotDetail, spotDetailSuccess, spotDetailData: spot } = spotsData;

    useEffect(() => {
        if (!openingSpotDetail && spot && spotDetailSuccess && spot.lat && spot.lng) {
            const map = new mapboxgl.Map({
                container: mapContainerRef.current,
                style: 'mapbox://styles/mapbox/outdoors-v12',
                center: [spot.lng, spot.lat],
                zoom: 15,
                attributionControl: false,
            });
            const el = document.createElement('div');
            el.className = 'mapboxgl-marker';
            el.innerHTML = ReactDOMServer.renderToStaticMarkup(
                <ThemeProvider theme={kwadHubTheme}>
                    <MarkerPoint spot={spot} />
                </ThemeProvider>
            );
            new mapboxgl.Marker(el, { anchor: 'bottom' }).setLngLat([spot.lng, spot.lat]).addTo(map);
        }
    }, [openingSpotDetail, spotDetailSuccess, spot]);

    return (
        <MiniMapContainer>
            <MapPlaceholderDiv ref={mapContainerRef} />
        </MiniMapContainer>
    );
};
export default MapPlaceholder;
